import { wrapFetch } from '../libs/fetch';
import type { ShowBrandCompany, Brand, BrandHeading, GroupedBrandIdsByInitial, ShowOtherBrandsByCompany } from '../types/brand';
import { SearchFormOptionsForRecruitments } from '../types/companies';
import type { BrandSummary } from '../types/companyDetail';

export const getShowBrandCompany = async (brandId: string | number) => {
  return await wrapFetch<ShowBrandCompany>(`/api/v1/brands/${brandId}/show_brand_company`);
};

export const getShowBrand = async (brandId: string | number) => {
  return await wrapFetch<Brand>(`/api/v1/brands/${brandId}/show_brand`);
};

export const getShowBrandHeading = async (brandId: string | number) => {
  return await wrapFetch<BrandHeading>(`/api/v1/brands/${brandId}/show_brand_heading`);
};

export const getGroupedBrandIds = async () => {
  return await wrapFetch<GroupedBrandIdsByInitial>('/api/v1/brands/grouped_brand_ids_by_initial');
};

export const getShowOtherBrandsByCompany = async (brandId: string | number) => {
  return await wrapFetch<ShowOtherBrandsByCompany>(`/api/v1/brands/${brandId}/show_other_brands_by_company`);
};

export const getShowBrandSummary = async (brandId: string | number) => {
  return await wrapFetch<BrandSummary>(`/api/v1/brands/${brandId}/show_brand_summary`);
};

export const getSearchBrandFormOptionsForRecruitment = async (brandId: number | string, status: 'released' | 'stopped' = 'released') => {
  return await wrapFetch<SearchFormOptionsForRecruitments>(
    `/api/v1/brands/get_search_form_options_for_recruitments?id=${brandId}&status=${status}`
  );
};
